module.exports = __webpack_public_path__ + "img/habilin2018_cover.e270e738.png";